// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════
   Weighing Scale Modal
═══════════════════════════════════════════════════ */

.wm-root {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 1300;
  outline: none;
}
.wm-root--mobile {
  align-items: flex-end;
  padding: 0;
}

.wm-modal {
  background: #fff;
  border-radius: 20px;
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18), 0 4px 16px rgba(0, 0, 0, 0.08);
  outline: none;
}
.wm-root--mobile .wm-modal {
  max-width: 100%;
  border-radius: 20px 20px 0 0;
}

/* ── Header ── */
.wm-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 24px 20px;
  position: relative;
  text-align: center;
}

.wm-settings-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
}
.wm-settings-btn:hover { background: #e2e8f0; color: #0f172a; }

.wm-icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  color: #2a71ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  box-shadow: 0 6px 20px rgba(42, 113, 255, 0.18);
}

.wm-title {
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 4px;
  letter-spacing: -0.02em;
}

.wm-product-name {
  font-size: 13px;
  color: #64748b;
  margin: 0;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wm-product-unit {
  display: inline-block;
  margin-top: 5px;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 20px;
  background: #eff6ff;
  color: #2a71ff;
  border: 1px solid #bfdbfe;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.dark .wm-product-unit {
  background: rgba(42, 113, 255, 0.12);
  color: #93c5fd;
  border-color: rgba(59, 130, 246, 0.3);
}

.wm-kg-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin: 8px 0 0;
  font-size: 11.5px;
  color: #64748b;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 7px 12px;
  line-height: 1.4;
}
.wm-kg-hint-row {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.wm-kg-hint strong { color: #0f172a; font-variant-numeric: tabular-nums; }
.wm-kg-hint-arrow { color: #94a3b8; font-size: 11px; }
.wm-kg-hint-label {
  font-size: 10px;
  color: #94a3b8;
  font-style: italic;
}
.wm-kg-hint-sep {
  font-size: 10px;
  font-weight: 700;
  color: #cbd5e1;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.dark .wm-kg-hint { background: #1e293b; border-color: #334155; color: #94a3b8; }
.dark .wm-kg-hint strong { color: #f1f5f9; }
.dark .wm-kg-hint-sep { color: #475569; }
.dark .wm-kg-hint-arrow { color: #475569; }
.dark .wm-kg-hint-label { color: #64748b; }

/* ── Body ── */
.wm-body {
  padding: 4px 24px 8px;
}

.wm-input-wrap {
  position: relative;
  display: flex;
  align-items: stretch;
}

.wm-input {
  flex: 1;
  height: 56px;
  border: 2px solid #e2e8f0;
  border-right: none;
  border-radius: 14px 0 0 14px;
  padding: 0 16px;
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  background: #f8fafc;
  outline: none;
  transition: border-color 0.15s;
  -moz-appearance: textfield;
}
.wm-input::-webkit-inner-spin-button,
.wm-input::-webkit-outer-spin-button { -webkit-appearance: none; }
.wm-input:focus { border-color: #2a71ff; background: #fff; }
.wm-input::placeholder { font-size: 16px; font-weight: 500; color: #cbd5e1; }

.wm-unit-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 52px;
  background: #2a71ff;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  border-radius: 0 14px 14px 0;
  letter-spacing: 0.03em;
}

.wm-scan-btn {
  width: 100%;
  height: 42px;
  margin-top: 12px;
  border-radius: 10px;
  border: 1.5px dashed #93c5fd;
  background: #f0f7ff;
  color: #2a71ff;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background 0.15s, border-color 0.15s;
}
.wm-scan-btn:hover { background: #dbeafe; border-color: #60a5fa; }

/* ── Footer ── */
.wm-footer {
  display: flex;
  gap: 10px;
  padding: 16px 24px 24px;
}

.wm-btn {
  flex: 1;
  height: 48px;
  border-radius: 12px;
  border: none;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background 0.15s, opacity 0.15s;
}

.wm-btn--cancel {
  background: #f1f5f9;
  color: #475569;
}
.wm-btn--cancel:hover { background: #e2e8f0; }

.wm-btn--add {
  background: #2a71ff;
  color: #fff;
  box-shadow: 0 4px 14px rgba(42, 113, 255, 0.3);
}
.wm-btn--add:hover:not(:disabled) { background: #1f63ea; }
.wm-btn--add:disabled { opacity: 0.4; cursor: not-allowed; box-shadow: none; }

/* ── Loading spinner ── */
.wm-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: wm-spin 0.7s linear infinite;
}
@keyframes wm-spin { to { transform: rotate(360deg); } }

/* ═══════════════════════════════════════════════════
   Dark mode
═══════════════════════════════════════════════════ */
.dark .wm-modal { background: #111827; }

.dark .wm-settings-btn { background: #1e293b; color: #64748b; }
.dark .wm-settings-btn:hover { background: #334155; color: #e2e8f0; }

.dark .wm-icon-wrap { background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%); color: #93c5fd; }
.dark .wm-title { color: #f1f5f9; }
.dark .wm-product-name { color: #64748b; }

.dark .wm-input { background: #1e293b; border-color: #334155; color: #f1f5f9; }
.dark .wm-input:focus { border-color: #3b82f6; background: #0f172a; }
.dark .wm-unit-badge { background: #1d4ed8; }

.dark .wm-scan-btn { background: #1e293b; border-color: #1e40af; color: #60a5fa; }
.dark .wm-scan-btn:hover { background: #1e3a5f; border-color: #3b82f6; }

.dark .wm-footer { }
.dark .wm-btn--cancel { background: #1e293b; color: #94a3b8; }
.dark .wm-btn--cancel:hover { background: #334155; }
.dark .wm-btn--add { background: #1d4ed8; box-shadow: 0 4px 14px rgba(29,78,216,0.4); }
.dark .wm-btn--add:hover:not(:disabled) { background: #1e40af; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/hooks/weighingModal.css"],"names":[],"mappings":"AAAA;;qDAEqD;;AAErD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2EAA2E;EAC3E,aAAa;AACf;AACA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;AACA,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA,qBAAqB,cAAc,EAAE,kCAAkC,EAAE;AACzE,oBAAoB,cAAc,EAAE,eAAe,EAAE;AACrD;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;AACA,oBAAoB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAChF,2BAA2B,cAAc,EAAE;AAC3C,wBAAwB,cAAc,EAAE;AACxC,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;;AAE1C,eAAe;AACf;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;uCACuC,wBAAwB,EAAE;AACjE,kBAAkB,qBAAqB,EAAE,gBAAgB,EAAE;AAC3D,yBAAyB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAE5E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gDAAgD;AAClD;AACA,qBAAqB,mBAAmB,EAAE,qBAAqB,EAAE;;AAEjE,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;AACA,oCAAoC,mBAAmB,EAAE;AACzD,wBAAwB,YAAY,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAE7E,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;AACzC;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD;;qDAEqD;AACrD,kBAAkB,mBAAmB,EAAE;;AAEvC,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;;AAEpE,sBAAsB,6DAA6D,EAAE,cAAc,EAAE;AACrG,kBAAkB,cAAc,EAAE;AAClC,yBAAyB,cAAc,EAAE;;AAEzC,kBAAkB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC9E,wBAAwB,qBAAqB,EAAE,mBAAmB,EAAE;AACpE,uBAAuB,mBAAmB,EAAE;;AAE5C,qBAAqB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACjF,2BAA2B,mBAAmB,EAAE,qBAAqB,EAAE;;AAEvE,mBAAmB;AACnB,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,8BAA8B,mBAAmB,EAAE;AACnD,qBAAqB,mBAAmB,EAAE,0CAA0C,EAAE;AACtF,0CAA0C,mBAAmB,EAAE","sourcesContent":["/* ═══════════════════════════════════════════════════\n   Weighing Scale Modal\n═══════════════════════════════════════════════════ */\n\n.wm-root {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  z-index: 1300;\n  outline: none;\n}\n.wm-root--mobile {\n  align-items: flex-end;\n  padding: 0;\n}\n\n.wm-modal {\n  background: #fff;\n  border-radius: 20px;\n  width: 100%;\n  max-width: 420px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18), 0 4px 16px rgba(0, 0, 0, 0.08);\n  outline: none;\n}\n.wm-root--mobile .wm-modal {\n  max-width: 100%;\n  border-radius: 20px 20px 0 0;\n}\n\n/* ── Header ── */\n.wm-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 28px 24px 20px;\n  position: relative;\n  text-align: center;\n}\n\n.wm-settings-btn {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: none;\n  background: #f1f5f9;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.wm-settings-btn:hover { background: #e2e8f0; color: #0f172a; }\n\n.wm-icon-wrap {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n  color: #2a71ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 14px;\n  box-shadow: 0 6px 20px rgba(42, 113, 255, 0.18);\n}\n\n.wm-title {\n  font-size: 17px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0 0 4px;\n  letter-spacing: -0.02em;\n}\n\n.wm-product-name {\n  font-size: 13px;\n  color: #64748b;\n  margin: 0;\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.wm-product-unit {\n  display: inline-block;\n  margin-top: 5px;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 20px;\n  background: #eff6ff;\n  color: #2a71ff;\n  border: 1px solid #bfdbfe;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n.dark .wm-product-unit {\n  background: rgba(42, 113, 255, 0.12);\n  color: #93c5fd;\n  border-color: rgba(59, 130, 246, 0.3);\n}\n\n.wm-kg-hint {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin: 8px 0 0;\n  font-size: 11.5px;\n  color: #64748b;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 7px 12px;\n  line-height: 1.4;\n}\n.wm-kg-hint-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.wm-kg-hint strong { color: #0f172a; font-variant-numeric: tabular-nums; }\n.wm-kg-hint-arrow { color: #94a3b8; font-size: 11px; }\n.wm-kg-hint-label {\n  font-size: 10px;\n  color: #94a3b8;\n  font-style: italic;\n}\n.wm-kg-hint-sep {\n  font-size: 10px;\n  font-weight: 700;\n  color: #cbd5e1;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n.dark .wm-kg-hint { background: #1e293b; border-color: #334155; color: #94a3b8; }\n.dark .wm-kg-hint strong { color: #f1f5f9; }\n.dark .wm-kg-hint-sep { color: #475569; }\n.dark .wm-kg-hint-arrow { color: #475569; }\n.dark .wm-kg-hint-label { color: #64748b; }\n\n/* ── Body ── */\n.wm-body {\n  padding: 4px 24px 8px;\n}\n\n.wm-input-wrap {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n}\n\n.wm-input {\n  flex: 1;\n  height: 56px;\n  border: 2px solid #e2e8f0;\n  border-right: none;\n  border-radius: 14px 0 0 14px;\n  padding: 0 16px;\n  font-size: 22px;\n  font-weight: 700;\n  color: #0f172a;\n  background: #f8fafc;\n  outline: none;\n  transition: border-color 0.15s;\n  -moz-appearance: textfield;\n}\n.wm-input::-webkit-inner-spin-button,\n.wm-input::-webkit-outer-spin-button { -webkit-appearance: none; }\n.wm-input:focus { border-color: #2a71ff; background: #fff; }\n.wm-input::placeholder { font-size: 16px; font-weight: 500; color: #cbd5e1; }\n\n.wm-unit-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 52px;\n  background: #2a71ff;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 800;\n  border-radius: 0 14px 14px 0;\n  letter-spacing: 0.03em;\n}\n\n.wm-scan-btn {\n  width: 100%;\n  height: 42px;\n  margin-top: 12px;\n  border-radius: 10px;\n  border: 1.5px dashed #93c5fd;\n  background: #f0f7ff;\n  color: #2a71ff;\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  transition: background 0.15s, border-color 0.15s;\n}\n.wm-scan-btn:hover { background: #dbeafe; border-color: #60a5fa; }\n\n/* ── Footer ── */\n.wm-footer {\n  display: flex;\n  gap: 10px;\n  padding: 16px 24px 24px;\n}\n\n.wm-btn {\n  flex: 1;\n  height: 48px;\n  border-radius: 12px;\n  border: none;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  transition: background 0.15s, opacity 0.15s;\n}\n\n.wm-btn--cancel {\n  background: #f1f5f9;\n  color: #475569;\n}\n.wm-btn--cancel:hover { background: #e2e8f0; }\n\n.wm-btn--add {\n  background: #2a71ff;\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(42, 113, 255, 0.3);\n}\n.wm-btn--add:hover:not(:disabled) { background: #1f63ea; }\n.wm-btn--add:disabled { opacity: 0.4; cursor: not-allowed; box-shadow: none; }\n\n/* ── Loading spinner ── */\n.wm-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255,255,255,0.4);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: wm-spin 0.7s linear infinite;\n}\n@keyframes wm-spin { to { transform: rotate(360deg); } }\n\n/* ═══════════════════════════════════════════════════\n   Dark mode\n═══════════════════════════════════════════════════ */\n.dark .wm-modal { background: #111827; }\n\n.dark .wm-settings-btn { background: #1e293b; color: #64748b; }\n.dark .wm-settings-btn:hover { background: #334155; color: #e2e8f0; }\n\n.dark .wm-icon-wrap { background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%); color: #93c5fd; }\n.dark .wm-title { color: #f1f5f9; }\n.dark .wm-product-name { color: #64748b; }\n\n.dark .wm-input { background: #1e293b; border-color: #334155; color: #f1f5f9; }\n.dark .wm-input:focus { border-color: #3b82f6; background: #0f172a; }\n.dark .wm-unit-badge { background: #1d4ed8; }\n\n.dark .wm-scan-btn { background: #1e293b; border-color: #1e40af; color: #60a5fa; }\n.dark .wm-scan-btn:hover { background: #1e3a5f; border-color: #3b82f6; }\n\n.dark .wm-footer { }\n.dark .wm-btn--cancel { background: #1e293b; color: #94a3b8; }\n.dark .wm-btn--cancel:hover { background: #334155; }\n.dark .wm-btn--add { background: #1d4ed8; box-shadow: 0 4px 14px rgba(29,78,216,0.4); }\n.dark .wm-btn--add:hover:not(:disabled) { background: #1e40af; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
